import {
  Directive,
  EffectRef,
  Injector,
  OnDestroy,
  Signal,
  TemplateRef,
  ViewContainerRef,
  effect,
  inject
} from '@angular/core';
import { FeatureConfigDirective } from './feature-config.directive';

/**
 * @description
 * Toggle show | hide templated content according to a specific boolean flag value which
 * is part of a feature's configuration > indication flags collection
 */
@Directive({
  standalone: true,
  exportAs: 'indTrue'
})
export abstract class IndicationConfigDirective extends FeatureConfigDirective implements OnDestroy {
  protected _containerRef = inject(ViewContainerRef);
  protected _templateRef = inject(TemplateRef);
  protected _localInjector = inject(Injector);
  protected _toggleRef: EffectRef;

  abstract value$$: Signal<boolean>;

  constructor() {
    super();
  }

  /**
   * @description
   * Monitor the boolean indication's value to reflect changes to the ui the boolean indication
   * is used to hide | show a template in the page.
   * When indication value is true - insert the template to the dom
   * when indication value is false - remove template from the dom
   */
  protected addChangeEffect() {
    this._toggleRef = effect(
      () => {
        if (!this.value$$) {
          return;
        }
        const isMatch = this.value$$();

        /** clear existing content */
        this._containerRef.clear();

        if (isMatch) {
          /** render the content */
          this._containerRef.createEmbeddedView(this._templateRef).detectChanges();
        }
      },
      { injector: this._localInjector }
    );
  }

  ngOnDestroy() {
    this._toggleRef && this._toggleRef.destroy();
  }
}
